import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import { collectionGet } from "@/common/api/rest/collection";

import type { CollectionType } from "@/common/types/collection";

import {
  TabCollectionInfos,
  TabCollectionDetails,
  TabCollectionPlatform,
  TabCollectionGallery,
} from "@/components";
import { breadcrumbSimple, iconMenu, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: '[tab]',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const selectedTab = ref("infos");
const collectionData = ref<CollectionType | null>(null);

const labelTypes = computed(() => ({
  console: t(`collection.labels.consoles`),
  game: t(`collection.labels.games`),
  accessorie: t(`collection.labels.accessories`),
}));

const collectionId = computed(() => route.params.collection as string);
const type = computed(() => route.params.type as string);

const breadcrumbList = computed(() => [
  {
    key: "collections",
    label: t("common.labels.collections"),
    url: `/collection`,
  },
  {
    key: "collection",
    label: labelTypes.value[type.value],
    url: `/collection/${type.value}`,
  },
  {
    key: "edit",
    label: collectionData.value?.name ?? "...",
  },
]);

const menuList = computed(() => [
  {
    key: "infos",
    icon: "field",
    label: t("collection.labels.infos"),
    url: `/collection/${type.value}/${collectionId.value}/infos`,
  },
  {
    key: "gallery",
    icon: "no-image",
    label: t("collection.labels.images"),
    url: `/collection/${type.value}/${collectionId.value}/gallery`,
  },
  {
    key: "platform",
    icon: "platform",
    label: t("collection.labels.platforms"),
    url: `/collection/${type.value}/${collectionId.value}/platform`,
  },
  {
    key: "details",
    icon: "no-image",
    label: t("collection.labels.details"),
    url: `/collection/${type.value}/${collectionId.value}/details`,
  },
]);

function back() {
  router.push(`/collection/${type.value}`);
}

async function changeMenu(url: string) {
  await fetchData();
  router.push(url);
}

// collection
async function fetchData() {
  await collectionGet(collectionId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        collectionData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watch(
  () => route.params.tab,
  () => {
    selectedTab.value = route.params.tab as string;
  },
  {
    immediate: true,
  }
);

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "gamepad",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("collection.labels.edit_collection")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default w-8 h-8",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(iconMenu), {
          tabs: menuList.value,
          active: selectedTab.value,
          size: "3rem",
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (changeMenu($event)))
        }, null, 8, ["tabs", "active"]),
        (collectionData.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (selectedTab.value === 'infos')
                ? (_openBlock(), _createBlock(_unref(TabCollectionInfos), {
                    key: 0,
                    "collection-id": collectionId.value,
                    collection: collectionData.value,
                    "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => (fetchData()))
                  }, null, 8, ["collection-id", "collection"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'details')
                ? (_openBlock(), _createBlock(_unref(TabCollectionDetails), {
                    key: 1,
                    collection: collectionData.value
                  }, null, 8, ["collection"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'platform')
                ? (_openBlock(), _createBlock(_unref(TabCollectionPlatform), {
                    key: 2,
                    collection: collectionData.value
                  }, null, 8, ["collection"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'gallery')
                ? (_openBlock(), _createBlock(_unref(TabCollectionGallery), {
                    key: 3,
                    collection: collectionData.value
                  }, null, 8, ["collection"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})